import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideCircleCheck, lucideSearch, lucideUserPlus, lucideMapPin, lucidePhone, lucideMail } from '@ng-icons/lucide';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { HlmBadgeImports } from '@spartan-ng/helm/badge';
import { HlmSeparatorImports } from '@spartan-ng/helm/separator';
import { matArrowForwardOutline } from '@ng-icons/material-symbols/outline';
import { FooterComponent } from '../components/footer/footer.component';

@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [
    RouterLink,
    NgIcon,
    HlmButtonImports,
    HlmCardImports,
    HlmBadgeImports,
    HlmSeparatorImports,
    FooterComponent
  ],
  templateUrl: './landing-page.html',
  styleUrls: ['./landing-page.css'],
  providers: [provideIcons({ lucideSearch, lucideMail, lucideUserPlus, lucideCircleCheck, matArrowForwardOutline, lucideMapPin, lucidePhone })]
})
export class LandingPageComponent {
  readonly registrationSteps = [
    { id: 1, title: 'Sign Up', description: 'Go to the registration page' },
    { id: 2, title: 'Fill Form', description: 'Complete all required fields accurately' },
    { id: 3, title: 'Payment', description: 'Securely complete the application fee' },
    { id: 4, title: 'Confirmation', description: 'Receive your application serial number' },
    { id: 5, title: 'Status Check', description: 'View the current status of your application' }
  ];

  readonly statusCheckSteps = [
    { id: 1, title: 'Enter Details', description: 'Provide your phone number and application serial number' },
    { id: 2, title: 'Verify Credentials', description: 'System validates your information' },
    { id: 3, title: 'View Status', description: 'See the current status of your application' },
  ];
  constructor() { }

}
